import React, { useEffect, useState } from "react";
import AdminNavbar from "../components/AdminNavbar";


const Statistics = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("mois");
  const [sessions, setSessions] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/sessions/stats`)	
      .then((res) => res.json())
      .then((data) => setStats(data))
      .catch((err) => console.error("Erreur stats :", err))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    const fetchSessions = async () => {
      try {
        let endpoint = "";
        switch (filter) {
          case "jour":
            endpoint = selectedDate ? `by-date?date=${selectedDate}` : "today";
            break;
          case "hier":
            endpoint = "yesterday";
            break;
          case "semaine":
            endpoint = "by-week";
            break;
          case "mois":
            endpoint = "by-month";
            break;
          default:
            endpoint = "today";
        }

        const url = `${process.env.REACT_APP_API_URL}/api/sessions/${endpoint}`;
        const res = await fetch(url);
        const data = await res.json();
        setSessions(data);
      } catch (err) {
        console.error("Erreur chargement sessions :", err);
      }
    };

    fetchSessions();
  }, [filter, selectedDate]);

  if (loading) {
    return (
      <div className="text-white text-center mt-20 text-xl">Chargement...</div>
    );
  }

  const filterRevenue = () => {
    switch (filter) {
      case "jour":
        return {
          title: selectedDate
            ? `📅 Recette du ${selectedDate}`
            : "📅 Recette du jour",
          value: stats.dailyRevenue,
        };
      case "hier":
        return {
          title: "🕙 Recette d’hier",
          value: stats.yesterdayRevenue,
        };
      case "semaine":
        return {
          title: "📆 Recette de la semaine",
          value: stats.weeklyRevenue,
        };
      case "mois":
      default:
        return {
          title: "📅 Recette du mois",
          value: stats.monthlyRevenue,
        };
    }
  };

  return (
    <div className="min-h-screen bg-[#0F0F0F] text-white p-8">
      <AdminNavbar />
      <h1 className="text-3xl font-bold mb-6 text-center neon-green">
        📊 Statistiques Générales
      </h1>

      {/* Filtres */}
      <div className="flex justify-center gap-4 mb-6 flex-wrap">
        {["jour", "hier", "semaine", "mois"].map((f) => (
          <button
            key={f}
            onClick={() => setFilter(f)}
            className={`px-4 py-2 rounded ${
              filter === f
                ? "bg-green-500 text-black"
                : "bg-[#1a1a1a] text-white"
            }`}
          >
            {f === "jour"
              ? "Aujourd’hui"
              : f === "hier"
              ? "Hier"
              : f === "semaine"
              ? "Semaine"
              : "Mois"}
          </button>
        ))}
        {filter === "jour" && (
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            className="px-3 py-2 bg-[#1a1a1a] text-white border rounded"
          />
        )}
      </div>

      {/* Résumé Recette */}
      <div className="bg-[#1a1a1a] p-6 rounded text-center shadow-lg mb-8">
        <h2 className="text-xl font-semibold text-yellow-400 mb-2">
          {filterRevenue().title}
        </h2>
        <p className="text-3xl">{filterRevenue().value} DT</p>
      </div>

      {/* Cahier de sessions */}
      <div className="bg-[#1a1a1a] p-6 rounded shadow">
        <h2 className="text-xl font-semibold text-blue-400 mb-4">
          📘 Sessions {filter === "jour" && selectedDate ? `du ${selectedDate}` : `de ${filter}`}
        </h2>
        {sessions.length === 0 ? (
          <p className="text-center text-gray-400">Aucune session trouvée.</p>
        ) : (
          <div className="overflow-auto">
            <table className="min-w-full text-sm text-left text-gray-200">
              <thead className="border-b border-gray-600">
                <tr>
                  <th className="py-2 px-4">Console</th>
                  <th className="py-2 px-4">Jeu</th>
                  <th className="py-2 px-4">Type</th>
                  <th className="py-2 px-4">Qté</th>
                  <th className="py-2 px-4">Prix</th>
                  <th className="py-2 px-4">Heure</th>
                  <th className="py-2 px-4">Gérant</th>
                </tr>
              </thead>
              <tbody>
                {sessions.map((s, idx) => (
                  <tr
                    key={idx}
                    className={`border-t border-gray-700 ${
                      idx % 2 === 0 ? "bg-[#1a1a1a]" : "bg-[#181818]"
                    }`}
                  >
                    <td className="py-1 px-4">{s.consoleName}</td>
                    <td className="py-1 px-4">{s.game}</td>
                    <td className="py-1 px-4 capitalize">{s.type}</td>
                    <td className="py-1 px-4">{s.quantity}</td>
                    <td className="py-1 px-4 text-green-400">
                      {parseFloat(s.price).toFixed(3)} DT
                    </td>
                    <td className="py-1 px-4">{s.formattedDate}</td>
                    <td className="py-1 px-4">{s.manager || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default Statistics;
